(function ($) {

	var backdropSelector = ".spinner-backdrop",
		spinningClass = "xom-spinning";

	$(function () {
		bindEvents();
	});

	function bindEvents() {
		
		$.subscribe('xom.spinner', function (evt, args) {
			var spinnerEl = $(args.elem)[0];
			if (args.mode)
				initSpinner(spinnerEl);
			else {
				stopSpinner(spinnerEl);
			}
		});

	}

	function initSpinner(elem) {
		var spinnerOpts = {
			lines: 12,
			length: 47,
			width: 15,
			radius: 45,
			scale: 1,
			corners: 1,
			opacity: 0.25,
			rotate: 0,
			direction: 1,
			speed: 1,
			trail: 60,
			color: "#0c479d",
			fadeColor: "transparent",
			shadow: "none"
		};

		var backdropHTML = '<div class="spinner-backdrop" />';
		//var spinnerElem = new Spinner().spin(elem);
		var spinner = new Spinner(spinnerOpts).spin();
		$(elem).addClass("xom-spinning").append(backdropHTML).append(spinner.el);
	}

	function stopSpinner(elem) {
		elem = $(elem);
		var spinner = elem.find(".spinner"),
			backdrop = elem.find(backdropSelector);
		if (spinner) {
			spinner.remove();
			backdrop.remove();
			elem.removeClass(spinningClass);
		}
	}

}(window.jQuery));

//from custom componet.js
(function ($) {
	var i = 0;
	var timer = setInterval(function () {
		i++;
		var element = $(".product-selector");
		if (element.length > 0) {
			$(".product-selector-spinner").hide();
			clearInterval(timer);
		}
		if (i === 10) clearInterval(timer);
	}, 1000);
}(window.jQuery));